import { Component, OnInit, ChangeDetectionStrategy, } from '@angular/core';
import { MsalService } from '@azure/msal-angular';

@Component({
    selector: 'app-logout-component',
    template: '',
    standalone: false
})

export class LogoutComponent implements OnInit {
  constructor(
    private authService: MsalService,
  ) {}

  ngOnInit() {
    this.authService.logout();
  }
}
